import React, { useState, useEffect } from 'react';
import './Dashboard.css'
import N3rveLogo from './../../../images/N3rveLogo.png'
import ProTag from './../../../images/protag.png'
import JpProTag from './../../../images/jp-protag.png'
import PopUpCheck from './../../../images/popupcheck.png'
import crossicon from './../../../images/crossicon.png'
import DashNavbarCross from './../../../images/dashnavbarcross.png'
import NavbarDesc from "./../../../images/navbar_desc.png"
import N3rvePlanLogo from "./../../../images/nervouspluslogo.png"
import N3rveProLogo from "./../../../images/nerveprologo.png"
import Home from './Home/Home';
import Music from './Music/Music';
import PromoteYourself from './PromoteYourself/PromoteYourself';
import ReleaseMusic from './ReleaseMusic/ReleaseMusic';
import Settings from './Settings/Settings';
import Support from './Support/Support';
import Money from './Wallet/Money';
import EnIcon from "./../../../images/englishicon.png"
import JapIcon from "./../../../images/japanicon.png"
import chinaicon from "./../../../images/chinaicon.png"
import koreaflag from "./../../../images/koreaflag.png"
import thaiflag from "./../../../images/thaiflag.png"
import vietflag from "./../../../images/vietflag.png"
import indoflag from "./../../../images/indoflag.png"
import N3rvePlusTick from './../../../images/nervetick.png'
import N3rvePremierTick from './../../../images/nervepremiertick.png'
import MobilePopup from './../../../images/mobilepopup.png'
import Analytics from './Analytics/Analytics';
import Exclusives from './Exclusives/Exclusives';
import { useLocation, useNavigate } from "react-router-dom";
import ReactModal from 'react-modal';
import Select from 'react-select'
import { Trans, useTranslation } from 'react-i18next'
import i18next from "i18next"
import Cookies from 'universal-cookie';
import axios from 'axios'
import { useJwt, decodeToken } from "react-jwt";
import { Route, Routes, Redirect, Navigate } from 'react-router-dom'
import { logtoWix } from '../../Helpers/LogToWix';


function Dashboard() {
  const [option, setOption] = useState("Home")
  const [scrollHeight, setScrollHeight] = useState(document.body.scrollHeight)
  const [popUp2, setpopUp2] = useState(false)
  const [languagedropdown, setLanguageDropdown] = useState(false)
  const [popUp3, setpopUp3] = useState(false)
  const [LogoutPopup, setLogoutPopup] = useState(false)
  const [artistName, setArtistName] = useState("")
  const [showDashboard, setShowDashboard] = useState(true)
  const [toggleDashBoard, setToggleDashboard] = useState(false)
  const [genre, setGenre] = useState()
  const navigate = useNavigate();
  const [language, setLanguage] = useState()
  const [sharedData, setSharedData] = useState([])
  const [prevScreen, setPrevScreen] = useState("")
  const [n3rvePopup, setN3rvePopup] = useState(false)
  const [n3rvePremierPopup, setN3rvePremierPopup] = useState(false)
  const [statehistory, setStateHistory] = useState()
  const [dashboardProps, setDashboardProps] = useState({
    fromAccountPage: false,
    fromLogin: false,
  });


  const genreOptions = [{ value: 'Alternative', label: 'Alternative' },
  { value: 'Audiobooks', label: 'Audiobooks' },
  { value: 'Blues', label: 'Blues' },
  { value: 'Children’s Music', label: 'Children’s Music' },
  { value: 'Classical', label: 'Classical' },
  { value: 'Comedy', label: 'Comedy' },
  { value: 'Country', label: 'Country' },
  { value: 'Dance', label: 'Dance' },
  { value: 'Electronic', label: 'Electronic' },
  { value: 'Folk', label: 'Folk' },
  { value: 'Hip hop/Rap', label: 'Hip hop/Rap' },
  { value: 'Holiday', label: 'Holiday' },
  { value: 'Inspirational', label: 'Inspirational' },
  { value: 'Jazz', label: 'Jazz' },
  { value: 'Latin', label: 'Latin' },
  { value: 'New Age', label: 'New Age' },
  { value: 'Opera', label: 'Opera' },
  { value: 'Pop', label: 'Pop' },
  { value: 'R&B/Soul', label: 'R&B/Soul' },
  { value: 'Reggae', label: 'Reggae' },
  { value: 'Rock', label: 'Rock' },
  { value: 'Spoken Word', label: 'Spoken Word' },
  { value: 'Soundtrack', label: 'Soundtrack' },
  { value: 'Vocal', label: 'Vocal' },
  { value: 'World', label: 'World' }]
  const { t, i18n } = useTranslation();
  const cookies = new Cookies(null, { path: '/' });
  const { decodedToken, isExpired } = useJwt(cookies.get("token"));
  const [dimensions, setDimensions] = useState({
    height: window.innerHeight,
    width: window.innerWidth
  });

  // const history = useNavigate();
  const { state } = useLocation();
  const location = useLocation();
  const [isOpen, setIsOpen] = useState();

  const changeGenreHandler = value => {
    setGenre(value)
  }

  const handleResize = () => {
    // console.log(window.innerWidth)
    setDimensions({
      width: window.innerWidth,
      height: window.innerHeight,
    });
    if (window.innerWidth >= 1024) {
      setToggleDashboard(false)
    }
  }

  window.onpopstate = (e) => {
    if (location.pathname === "/Dashboard") {
      setShowDashboard(true)
      setOption("Home")
    }
    if (location.pathname === "/Dashboard/releasemusic") {
      setOption("ReleaseMusic")
    }
    if (location.pathname === "/Dashboard/music") {
      setShowDashboard(true)
      setOption("Music")
    }

    if (location.pathname === "/Dashboard/analytics") {
      setShowDashboard(true)
      setOption("Analytics")
    }

    if (location.pathname === "/Dashboard/money") {
      setShowDashboard(true)
      setOption("Money")
    }

    if (location.pathname === "/Dashboard/exclusives") {
      setShowDashboard(true)
      setOption("Exclusives")
    }

    if (location.pathname === "/Dashboard/promoteyourself") {
      setShowDashboard(true)
      setOption("PromoteYourself")
    }

    if (location.pathname === "/Dashboard/settings") {
      setShowDashboard(true)
      setOption("Settings")
    }

    if (location.pathname === "/help") {
      setOption("Support")
    }
  }

  const colourStyles = {
    control: styles => ({
      ...styles, borderColor: '#636468',
      backgroundColor: '#18191F',
      width: '25.75em',
      height: '3em',
      borderRadius: '4px',
      color: 'rgba(255, 255, 255, 1)',
      marginTop: '0.8em',
      marginLeft: '2em'
    }),
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
      return {
        ...styles,
        backgroundColor: '#18191F',
        color: 'rgba(255, 255, 255, 1)',
        cursor: isDisabled ? 'not-allowed' : 'default',
        marginTop: '-0.3em',
        marginBottom: '-0.3em'
      };
    },
    input: (styles) => ({
      ...styles,
      FontFamily: 'ClashGrotesk-Variable,sans-serif',
      FontSize: '1rem',
      FontWeight: 'medium',
      LineHeight: '150%',
      LetterSpacing: '0%',
      color: 'rgba(255, 255, 255, 1)'
    }),
    singleValue: (styles) => ({
      ...styles,
      color: 'rgba(255, 255, 255, 1)',
      FontFamily: 'ClashGrotesk-Variable,sans-serif',
      FontSize: '1rem',
      FontWeight: 'medium',
      LineHeight: '150%',
      LetterSpacing: '0%'
    }),
    menuList: (base) => ({
      ...base,
      "::-webkit-scrollbar": {
        width: "0px",
        height: "0px",
      },
      "::-webkit-scrollbar-track": {
        background: "#f1f1f1"
      },
      "::-webkit-scrollbar-thumb": {
        background: "#888"
      },
      "::-webkit-scrollbar-thumb:hover": {
        background: "#555"
      }
    })
  };




  useEffect(() => {

  }, [scrollHeight])

  useEffect(() => {
    if (state !== null) {
      if (state.fromLogin) {
        window.history.pushState(null, '', window.location.pathname);

        const handlePopState = (event) => {
          window.history.pushState(null, '', window.location.pathname)
        };

        window.addEventListener('popstate', handlePopState);

        return () => {
          window.removeEventListener('popstate', handlePopState);
        };
        console.log("Back pressed")
      }
    }
  }, [navigate])

  const termsansdconditions = () => {
    axios({
      method: 'post',
      url: "https://n3rve.fly.dev/auth/signup/tnc",
      headers: {
        Authorization: "Bearer ".concat(cookies.get("token"))
      }
    }).then((response) => {
      setpopUp2(false);
      if (response.status === 200) {
        console.log("TNC Route successful")
        console.log(response)
        cookies.set('token', response.data.token)
      }
    }).catch(function (e) {
      console.log(e.response)
    })
  }

  const finalizeuser = () => {

    console.log(genre.value.toUpperCase())
    axios({
      method: 'post',
      url: "https://n3rve.fly.dev/auth/signup/final",
      headers: {
        Authorization: "Bearer ".concat(cookies.get("token"))
      },
      data: {
        "artistName": artistName,
        "genres": [genre.value.toUpperCase()]
      }
    }).then((response) => {
      if (response.status === 200) {
        console.log(response)
        setIsOpen(false);
        setpopUp2(false);
        setpopUp3(false);
      }
    }).catch(function (e) {
      console.log(e.response)
    })
  }


  const pull_data = (data) => {
    setScrollHeight(data)
    return data
  }

  const changeScreen = (data) => {
    setOption(data)
  }

  const hideDashboard = (data) => {
    setShowDashboard(data)
  }

  const shareData = (data) => {
    setSharedData(data)
  }

  const toggleN3rvePopup = (data) => {
    setN3rvePopup(data)
  }

  const toggleN3rvePremierPopup = (data) => {
    setN3rvePremierPopup(data)
  }

  const prevPage = (data) => {
    setPrevScreen(data)
  }

  useEffect(() => {
    setScrollHeight('65.625em')
  }, [option])

  useEffect(() => {

  }, [language])

  useEffect(() => {
    // if(state.fromLogin){
    //   window.history.pushState(null,'',window.location.pathname);
    //   const handlePopState = (event)=>{
    //         window.history.pushState(null,'',window.location.pathname)
    //   };
    //   window.addEventListener('popstate',handlePopState);
    //   return () => {
    //         window.removeEventListener('popstate',handlePopState);
    //       };
    // }

    const storedProps = localStorage.getItem('dashboardProps');

    if (storedProps) {
      setDashboardProps(JSON.parse(storedProps));
    }

    if (state !== null) {
      setIsOpen(state.fromAccountPage)
    }

    console.log("Landed on this page from ", state)
    // cookies.set('artistname', "")
    window.addEventListener("resize", handleResize, false);
    console.log(decodeToken(cookies.get('token')))
    if (cookies.get('lang') === 'en') {
      setLanguage('English')
      i18next.changeLanguage('en');
    }

    if (cookies.get('lang') === 'jp') {
      setLanguage('日本語')
      i18next.changeLanguage('jp');
    }
    if (decodeToken(cookies.get('token')).info !== undefined) {
      if (decodeToken(cookies.get('token')).info.artistName !== undefined) {
        cookies.set('artistname', decodeToken(cookies.get('token')).info.artistName.toString())
      }
    }

    if (location.pathname === "/Dashboard") {
      setOption("Home")
    }
    if (location.pathname === "/Dashboard/releasemusic") {
      setOption("ReleaseMusic")
    }
    if (location.pathname === "/Dashboard/music") {
      setOption("Music")
    }

    if (location.pathname === "/Dashboard/analytics") {
      setOption("Analytics")
    }

    if (location.pathname === "/Dashboard/money") {
      setOption("Money")
    }

    if (location.pathname === "/Dashboard/exclusives") {
      setOption("Exclusives")
    }

    if (location.pathname === "/Dashboard/promoteyourself") {
      setOption("PromoteYourself")
    }

    if (location.pathname === "/Dashboard/settings") {
      setOption("Settings")
    }

    if (location.pathname === "/help") {
      setOption("Support")
    }

    localStorage.removeItem('dashboardProps');
    // window.onpopstate = e =>{
    //   navigate("/")
    // }
  }, [])

  const handleLogout = () => {
    if (cookies.get('token') !== undefined) {
      if (decodeToken(cookies.get('token')) !== null) {
        logtoWix(decodeToken(cookies.get('token')).email, "logout", "Artist Dashboard", { "desc": "User logged out" })
      } else {
        logtoWix("anonymous user", "logout", "Artist Dashboard", { "desc": "User logged out" })
      }
    } else {
      logtoWix("anonymous user", "logout", "Artist Dashboard", { "desc": "User logged out" })
    }

    cookies.set('token', undefined)
    cookies.set('staysignedin', false)
    navigate("/")
  }


  function closen3rvePremierPopup() {
    setN3rvePremierPopup(false)
  }

  function closeNervePlusPopup() {
    setIsOpen(false)
  }

  function closeTOSPopup() {
    setpopUp2(false)
  }

  function closeCreateProfilePopup() {
    setpopUp3(false)
  }

  function closeLogoutPopup() {
    setLogoutPopup(false)
  }

  return (
    <div className="Dashboard">




      {/* backgroundImage:`url(${DashboardBackground})`, */}
      {
        dimensions.width >= 1024 && showDashboard &&
        <div className='DashboardDrawer' style={{ backgroundImage: `url("https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/xc7fkmxojffjwlwhwd0c")`, position: 'fixed', zIndex: '3' }} >
          <div>
            <img src={N3rveLogo} alt="Nerve Logo" className='Logo' style={{ width: '6.15em', height: '1.125em', cursor: 'pointer' }} onClick={() => navigate("/")} />
            {
              option === "Home" &&
              <div className='DashboardMenuItemSelected' style={{ cursor: 'pointer' }}>{t('Home')}</div>
            }

            {
              option !== "Home" &&
              <div className='DashboardMenuItem' onClick={() => { navigate("/Dashboard", { state: { fromAccountPage: false, fromLogin: false } }); setOption('Home') }} style={{ cursor: 'pointer' }}>{t('Home')}</div>
            }

            {
              option === "ReleaseMusic" &&
              <div className='DashboardMenuItemSelected' style={{ cursor: 'pointer' }}>{t('Releasemusic')}</div>
            }

            {
              option !== "ReleaseMusic" &&
              <div className='DashboardMenuItem' onClick={() => { navigate("/Dashboard/releasemusic"); setOption('ReleaseMusic') }} style={{ cursor: 'pointer' }}>{t('Releasemusic')}</div>
            }

            {
              option === "Music" &&
              <div className='DashboardMenuItemSelected' style={{ cursor: 'pointer' }}>{t('Music')}</div>
            }

            {
              option !== "Music" &&
              <div className='DashboardMenuItem' onClick={() => { navigate("/Dashboard/music"); setOption('Music') }} style={{ cursor: 'pointer' }}>{t('Music')}</div>
            }

            {
              option === "Analytics" &&
              <div className='DashboardMenuItemSelected' style={{ cursor: 'pointer' }}>{t('Analytics')}</div>
            }

            {
              option !== "Analytics" &&
              <div className='DashboardMenuItem' onClick={() => { navigate("/Dashboard/analytics"); setOption('Analytics') }} style={{ cursor: 'pointer' }}>{t('Analytics')}</div>
            }

            {
              option === "Wallet" &&
              <div className='DashboardMenuItemSelected' style={{ cursor: 'pointer' }}>Money</div>
            }

            {
              option !== "Wallet" &&
              <div className='DashboardMenuItem' onClick={() => { navigate("/Dashboard/money"); setOption('Wallet') }} style={{ cursor: 'pointer' }}>Money</div>
            }

            {
              option === "PromoteYourself" &&
              <div className='DashboardMenuItemSelected' style={{ cursor: 'pointer' }}>{t('Promoteyourself')}</div>
            }

            {
              option !== "PromoteYourself" &&
              <div className='DashboardMenuItem' onClick={() => { navigate("/Dashboard/promoteyourself"); setOption('PromoteYourself') }} style={{ cursor: 'pointer' }}>{t('Promoteyourself')}</div>
            }


            {
              option !== "Exclusives" &&
              <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', cursor: 'pointer' }} className='DashboardMenuItem' onClick={() => { navigate("/Dashboard/exclusives"); setOption('Exclusives') }}>
                <div>{t('Exclusives')}</div>
                {
                  cookies.get('lang') === 'en' && <img src={ProTag} alt="Pro Tag" className='ProTag' />
                }
                {
                  cookies.get('lang') === 'jp' && <img src={JpProTag} alt="Pro Tag" className='ProTag' />
                }

              </div>
            }

            {
              option === "Exclusives" &&
              <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', cursor: 'pointer' }} className='DashboardMenuItemSelected'>
                <div>{t('Exclusives')}</div>
                {
                  cookies.get('lang') === 'en' && <img src={ProTag} alt="Pro Tag" className='ProTag' />
                }
                {
                  cookies.get('lang') === 'jp' && <img src={JpProTag} alt="Pro Tag" className='ProTag' />
                }
              </div>
            }

            {
              option !== "Settings" &&
              <div className='DashboardSettingItem' onClick={() => { navigate("/Dashboard/settings"); setOption('Settings') }} style={{ cursor: 'pointer', marginTop: '0.3em' }}>{t('Settings')}</div>
            }

            {
              option === "Settings" &&
              <div className='DashboardSettingItemSelected' style={{ cursor: 'pointer', marginTop: '0.3em' }}>{t('Settings')}</div>
            }

            {
              option !== "Support" &&
              <div className='DashboardSettingItem' onClick={() => { navigate("/help"); setOption('Support') }} style={{ cursor: 'pointer' }}>{t('Support')}</div>
            }

            {
              option === "Support" &&
              <div className='DashboardSettingItemSelected' style={{ cursor: 'pointer' }}>{t('Support')}</div>
            }



            <div className='DashboardSettingItem' style={{ cursor: 'pointer' }} onClick={() => setLogoutPopup(true)}>{t('Logout')}</div>
          </div>

          <div style={{ position: 'relative' }}>
            {
              languagedropdown &&
              <div style={{ backgroundColor: 'transparent', position: 'absolute', marginTop: '-8.5em', marginLeft: '10em' }} onMouseLeave={() => setLanguageDropdown(false)} >
                <div style={{ backgroundColor: '#1D2024', marginTop: '0.4em', paddingBottom: '0.3em', border: '1px #8C8C8C solid', borderRadius: '8px', paddingTop: '0.3em', paddingBottom: '0.3em', paddingLeft: '0.5em', paddingRight: '0.5em', position: 'absolute', top: '-10em', marginLeft: '-1em' }} onMouseOver={() => setLanguageDropdown(true)} onMouseLeave={() => setLanguageDropdown(false)}>
                  <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: '0.625em' }}>
                    <img src={EnIcon} style={{ width: '24px', height: '24px', borderRadius: '99px' }} />
                    <div value={'en'} className='LanguageOption' onClick={() => { i18next.changeLanguage('en'); cookies.set('lang', 'en'); setLanguage('English'); setLanguageDropdown(!languagedropdown) }}>English</div>
                  </div>

                  <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: '0.625em' }}>
                    <img src={JapIcon} style={{ width: '24px', height: '24px', borderRadius: '99px' }} />
                    <div value={'jp'} className='LanguageOption' onClick={() => { i18next.changeLanguage('jp'); cookies.set('lang', 'jp'); setLanguage('日本語'); setLanguageDropdown(!languagedropdown) }}>日本語</div>
                  </div>

                  <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: '0.625em' }}>
                    <img src={koreaflag} style={{ width: '24px', height: '24px', borderRadius: '99px' }} />
                    <div value={'en'} className='LanguageOption' onClick={() => { i18next.changeLanguage('en'); cookies.set('lang', 'en'); setLanguage('English'); setLanguageDropdown(!languagedropdown) }}>한국어</div>
                  </div>

                  <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: '0.625em' }}>
                    <img src={chinaicon} style={{ width: '24px', height: '24px', borderRadius: '99px' }} />
                    <div value={'en'} className='LanguageOption' onClick={() => { i18next.changeLanguage('en'); cookies.set('lang', 'en'); setLanguage('English'); setLanguageDropdown(!languagedropdown) }}>中文</div>
                  </div>

                  <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: '0.625em' }}>
                    <img src={thaiflag} style={{ width: '24px', height: '24px', borderRadius: '99px' }} />
                    <div value={'en'} className='LanguageOption' onClick={() => { i18next.changeLanguage('en'); cookies.set('lang', 'en'); setLanguage('English'); setLanguageDropdown(!languagedropdown) }}>ไทย</div>
                  </div>

                  <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: '0.625em' }}>
                    <img src={vietflag} style={{ width: '24px', height: '24px', borderRadius: '99px' }} />
                    <div value={'en'} className='LanguageOption' onClick={() => { i18next.changeLanguage('en'); cookies.set('lang', 'en'); setLanguage('English'); setLanguageDropdown(!languagedropdown) }}>Tiếng Việt</div>
                  </div>

                  <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: '0.625em' }}>
                    <img src={indoflag} style={{ width: '24px', height: '24px', borderRadius: '99px' }} />
                    <div value={'en'} className='LanguageOption' onClick={() => { i18next.changeLanguage('en'); cookies.set('lang', 'en'); setLanguage('English'); setLanguageDropdown(!languagedropdown) }}>Bahasa<br /> Indonesia</div>
                  </div>
                </div>
              </div>
            }

            <div className='DashboardLanguageItem'>Select language <span style={{ textDecoration: 'underline', cursor: 'pointer' }} onClick={() => setLanguageDropdown(!languagedropdown)}>{language}</span></div>
            <div className='DashboardCopyrightItem'>&copy; 2024 N3RVE {t('Allrightsreserved')}</div>
          </div>
        </div>
      }



      {
        dimensions.width >= 768 &&
        <div className={dimensions.width >= 768 && dimensions.width < 1024 ? 'DashboardComponentTablet' : 'DashboardComponent'} >

          {/* {
             option==="Home" &&
             <Home func={pull_data} nav={changeScreen}/>
           } 
 
           {
             option==="ReleaseMusic" &&
             <ReleaseMusic hidedashboard={hideDashboard} func={pull_data} nav={changeScreen} sharedData={sharedData} prevInfo={prevScreen} prevPage={prevPage} shareData={shareData}/>
           }
 
           {
             option==="Music" &&
             <Music nav={changeScreen} shareData={shareData} prevPage={prevPage}/>
           }
 
           {
             option==="Analytics" &&
             <Analytics axiosInstace={state.axiosInstace} nav={changeScreen} />
           }
 
           {
             option==="Wallet" &&
             <Money nav={changeScreen} />
           }
 
           {
             option==="Exclusives" &&
             <Exclusives />
           }
         
 
           {
             option==="PromoteYourself" &&
             <PromoteYourself hidedashboard={hideDashboard} nav={changeScreen}/>
           }
 
           {
             option==="Settings" &&
             <Settings hidedashboard={hideDashboard} nav={changeScreen}/>
           }
 
           {
             option==="Support" &&
             <Support hidedashboard={hideDashboard}  nav={changeScreen} />
           } */}
          {/* {
            dimensions.width>=1024 &&
            <div style={{width:'22.3%',height:'100vh',backgroundColor:'transparent',position:'fixed', max-width:20em;}}/>
           } */}




          <Routes>
            <Route path="/" element={<Home func={pull_data} hidedashboard={hideDashboard} nav={changeScreen} />} />
            <Route exact path="/releasemusic/*" element={<ReleaseMusic hidedashboard={hideDashboard} func={pull_data} nav={changeScreen} sharedData={sharedData} prevScreen={prevScreen} prevPage={prevPage} shareData={shareData} />} />
            <Route exact path="/music/*" element={<Music nav={changeScreen} hidedashboard={hideDashboard} shareData={shareData} prevPage={prevPage} />} />
            <Route exact path="/analytics" element={<Analytics hidedashboard={hideDashboard} nav={changeScreen} />} />
            <Route exact path="/money/*" element={<Money hidedashboard={hideDashboard} nav={changeScreen} />} />
            <Route exact path="/exclusives" element={<Exclusives hidedashboard={hideDashboard} nav={changeScreen} />} />
            <Route exact path="/promoteyourself/*" element={<PromoteYourself hidedashboard={hideDashboard} nav={changeScreen} />} />
            <Route exact path="/settings/*" element={<Settings hidedashboard={hideDashboard} nav={changeScreen} />} />
          </Routes>

        </div>
      }

      {
        dimensions.width < 768 &&
        <div className='DashboardComponent' style={{ marginLeft: '0em' }}>
          <ReactModal
            isOpen={true}
            contentLabel="Example Modal"
            className="MobilePopupContainer"
            overlayClassName="Overlay"
          >

            <img src={MobilePopup} style={{ marginTop: '2em', width: '100%', marginBottom: '1em' }} />


            <div className="MobilePopupHeader">
              Experience Full Features on Desktop
            </div>

            <div className="MobilePopupInfo">
              Looks like you're on mobile. For the full suite of features, please switch to desktop. Some functionalities might be limited here.
            </div>




          </ReactModal>
          {
            option === "Home" &&
            <Home func={pull_data} nav={changeScreen} hidedashboard={hideDashboard} />
          }

          {
            option === "ReleaseMusic" &&
            <ReleaseMusic hidedashboard={hideDashboard} func={pull_data} nav={changeScreen} sharedData={sharedData} prevInfo={prevScreen} prevPage={prevPage} shareData={shareData} />
          }

          {
            option === "Music" &&
            <Music nav={changeScreen} shareData={shareData} prevPage={prevPage} hidedashboard={hideDashboard} />
          }

          {
            option === "Analytics" &&
            <Analytics hidedashboard={hideDashboard} nav={changeScreen} />
          }

          {
            option === "Wallet" &&
            <Money hidedashboard={hideDashboard} nav={changeScreen} />
          }

          {
            option === "Exclusives" &&
            <Exclusives hidedashboard={hideDashboard} nav={changeScreen} />
          }


          {
            option === "PromoteYourself" &&
            <PromoteYourself hidedashboard={hideDashboard} nav={changeScreen} />
          }

          {
            option === "Settings" &&
            <Settings hidedashboard={hideDashboard} nav={changeScreen} />
          }

          {
            option === "Support" &&
            <Support hidedashboard={hideDashboard} nav={changeScreen} />
          }
        </div>
      }

      {
        dimensions.width < 1024 && showDashboard &&
        <div className='DashboardDrawer' style={{ marginLeft: '0em', height: '5em' }}>
          <div style={{ display: 'flex', flexDirection: 'row', height: '3.01em', alignItems: 'center', marginTop: '1.5em', position: 'relative' }}>
            <img src={NavbarDesc} style={{ height: '2.14em', width: '2.14em', marginLeft: '1em', cursor: 'pointer' }} onClick={() => setToggleDashboard(true)} />
            <img src={N3rveLogo} style={{ height: '1.31em', width: '7.18em', marginLeft: '1em' }} />
            {
              toggleDashBoard &&
              <div style={{ position: 'absolute', backgroundImage: 'linear-gradient(90deg, rgba(19,19,23,1) 0%, rgba(16,16,20,0) 100%)', backgroundColor: 'rgba(0,0,0,90%)', width: '20em', top: '-1.5em' }}>
                <img src={DashNavbarCross} style={{ width: '2.14em', height: '2.14em', marginLeft: '1em', marginTop: '2em', marginBottom: '2.04em', cursor: 'pointer' }} onClick={() => setToggleDashboard(false)} />

                {
                  option === "Home" &&
                  <div className='DashboardMenuItemSelected' onClick={() => { navigate("/Dashboard"); setOption("Home"); setToggleDashboard(false) }} style={{ cursor: 'pointer' }}>{t('Home')}</div>
                }

                {
                  option !== "Home" &&
                  <div className='DashboardMenuItem' onClick={() => { navigate("/Dashboard"); setOption("Home"); setToggleDashboard(false) }} style={{ cursor: 'pointer' }}>{t('Home')}</div>
                }

                {
                  option === "ReleaseMusic" &&
                  <div className='DashboardMenuItemSelected' onClick={() => { navigate("/Dashboard/releasemusic"); setOption("ReleaseMusic"); setToggleDashboard(false) }} style={{ cursor: 'pointer' }}>{t('Releasemusic')}</div>
                }

                {
                  option !== "ReleaseMusic" &&
                  <div className='DashboardMenuItem' onClick={() => { navigate("/Dashboard/releasemusic"); setOption("ReleaseMusic"); setToggleDashboard(false) }} style={{ cursor: 'pointer' }}>{t('Releasemusic')}</div>
                }

                {
                  option === "Music" &&
                  <div className='DashboardMenuItemSelected' onClick={() => { navigate("/Dashboard/music"); setOption("Music"); setToggleDashboard(false) }} style={{ cursor: 'pointer' }}>{t('Music')}</div>
                }

                {
                  option !== "Music" &&
                  <div className='DashboardMenuItem' onClick={() => { navigate("/Dashboard/music"); setOption("Music"); setToggleDashboard(false) }} style={{ cursor: 'pointer' }}>{t('Music')}</div>
                }

                {
                  option === "Analytics" &&
                  <div className='DashboardMenuItemSelected' onClick={() => { navigate("/Dashboard/analytics"); setOption("Analytics"); setToggleDashboard(false) }} style={{ cursor: 'pointer' }}>{t('Analytics')}</div>
                }

                {
                  option !== "Analytics" &&
                  <div className='DashboardMenuItem' onClick={() => { navigate("/Dashboard/analytics"); setOption("Analytics"); setToggleDashboard(false) }} style={{ cursor: 'pointer' }}>{t('Analytics')}</div>
                }

                {
                  option === "Wallet" &&
                  <div className='DashboardMenuItemSelected' onClick={() => { navigate("/Dashboard/money"); setOption("Wallet"); setToggleDashboard(false) }} style={{ cursor: 'pointer' }}>Money</div>
                }

                {
                  option !== "Wallet" &&
                  <div className='DashboardMenuItem' onClick={() => { navigate("/Dashboard/money"); setOption("Wallet"); setToggleDashboard(false) }} style={{ cursor: 'pointer' }}>Money</div>
                }

                {
                  option === "PromoteYourself" &&
                  <div className='DashboardMenuItemSelected' onClick={() => { navigate("/Dashboard/promoteyourself"); setOption("PromoteYourself"); setToggleDashboard(false) }} style={{ cursor: 'pointer' }}>{t('Promoteyourself')}</div>
                }

                {
                  option !== "PromoteYourself" &&
                  <div className='DashboardMenuItem' onClick={() => { navigate("/Dashboard/promoteyourself"); setOption("PromoteYourself"); setToggleDashboard(false) }} style={{ cursor: 'pointer' }}>{t('Promoteyourself')}</div>
                }


                {
                  option !== "Exclusives" &&
                  <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', cursor: 'pointer' }} className='DashboardMenuItem' onClick={() => { navigate("/Dashboard/exclusives"); setOption("Exclusives"); setToggleDashboard(false) }}>
                    <div>{t('Exclusives')}</div>
                    {
                      cookies.get('lang') === 'en' && <img src={ProTag} alt="Pro Tag" className='ProTag' />
                    }
                    {
                      cookies.get('lang') === 'jp' && <img src={JpProTag} alt="Pro Tag" className='ProTag' />
                    }

                  </div>
                }

                {
                  option === "Exclusives" &&
                  <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', cursor: 'pointer' }} className='DashboardMenuItemSelected' onClick={() => { navigate("/Dashboard/exclusives"); setOption("Exclusives"); setToggleDashboard(false) }}>
                    <div>{t('Exclusives')}</div>
                    {
                      cookies.get('lang') === 'en' && <img src={ProTag} alt="Pro Tag" className='ProTag' />
                    }
                    {
                      cookies.get('lang') === 'jp' && <img src={JpProTag} alt="Pro Tag" className='ProTag' />
                    }
                  </div>
                }

                {
                  option !== "Settings" &&
                  <div className='DashboardSettingItem' onClick={() => { navigate("/Dashboard/settings"); setOption("Settings"); setToggleDashboard(false) }} style={{ cursor: 'pointer', marginTop: '0.3em' }}>{t('Settings')}</div>
                }

                {
                  option === "Settings" &&
                  <div className='DashboardSettingItemSelected' onClick={() => { navigate("/Dashboard/settings"); setOption("Settings"); setToggleDashboard(false) }} style={{ cursor: 'pointer', marginTop: '0.3em' }}>{t('Settings')}</div>
                }

                {
                  option !== "Support" &&
                  <div className='DashboardSettingItem' onClick={() => { navigate("/help"); setOption("Support"); setToggleDashboard(false) }} style={{ cursor: 'pointer' }}>{t('Support')}</div>
                }

                {
                  option === "Support" &&
                  <div className='DashboardSettingItemSelected' onClick={() => { navigate("/help"); setOption("Support"); setToggleDashboard(false) }} style={{ cursor: 'pointer' }}>{t('Support')}</div>
                }



                <div className='DashboardSettingItem' style={{ cursor: 'pointer', marginBottom: '4em' }} onClick={() => setLogoutPopup(true)}>{t('Logout')}</div>


                <div style={{ position: 'relative', marginLeft: '0.3em' }}>
                  {
                    languagedropdown &&
                    <div style={{ backgroundColor: 'transparent', position: 'absolute', marginTop: '-8.5em', marginLeft: '10em' }} onMouseLeave={() => setLanguageDropdown(false)} >
                      <div style={{ backgroundColor: '#1D2024', marginTop: '0.4em', paddingBottom: '0.3em', border: '1px #8C8C8C solid', borderRadius: '8px', paddingTop: '0.3em', paddingBottom: '0.3em', paddingLeft: '0.5em', paddingRight: '0.5em', position: 'absolute', top: '-10em', marginLeft: '-1em' }} onMouseOver={() => setLanguageDropdown(true)} onMouseLeave={() => setLanguageDropdown(false)}>
                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: '0.625em' }}>
                          <img src={EnIcon} style={{ width: '24px', height: '24px', borderRadius: '99px' }} />
                          <div value={'en'} className='LanguageOption' onClick={() => { i18next.changeLanguage('en'); cookies.set('lang', 'en'); setLanguage('English'); setLanguageDropdown(!languagedropdown) }}>English</div>
                        </div>

                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: '0.625em' }}>
                          <img src={JapIcon} style={{ width: '24px', height: '24px', borderRadius: '99px' }} />
                          <div value={'jp'} className='LanguageOption' onClick={() => { i18next.changeLanguage('jp'); cookies.set('lang', 'jp'); setLanguage('日本語'); setLanguageDropdown(!languagedropdown) }}>日本語</div>
                        </div>

                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: '0.625em' }}>
                          <img src={koreaflag} style={{ width: '24px', height: '24px', borderRadius: '99px' }} />
                          <div value={'en'} className='LanguageOption' onClick={() => { i18next.changeLanguage('en'); cookies.set('lang', 'en'); setLanguage('English'); setLanguageDropdown(!languagedropdown) }}>한국어</div>
                        </div>

                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: '0.625em' }}>
                          <img src={chinaicon} style={{ width: '24px', height: '24px', borderRadius: '99px' }} />
                          <div value={'en'} className='LanguageOption' onClick={() => { i18next.changeLanguage('en'); cookies.set('lang', 'en'); setLanguage('English'); setLanguageDropdown(!languagedropdown) }}>中文</div>
                        </div>

                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: '0.625em' }}>
                          <img src={thaiflag} style={{ width: '24px', height: '24px', borderRadius: '99px' }} />
                          <div value={'en'} className='LanguageOption' onClick={() => { i18next.changeLanguage('en'); cookies.set('lang', 'en'); setLanguage('English'); setLanguageDropdown(!languagedropdown) }}>ไทย</div>
                        </div>

                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: '0.625em' }}>
                          <img src={vietflag} style={{ width: '24px', height: '24px', borderRadius: '99px' }} />
                          <div value={'en'} className='LanguageOption' onClick={() => { i18next.changeLanguage('en'); cookies.set('lang', 'en'); setLanguage('English'); setLanguageDropdown(!languagedropdown) }}>Tiếng Việt</div>
                        </div>

                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: '0.625em' }}>
                          <img src={indoflag} style={{ width: '24px', height: '24px', borderRadius: '99px' }} />
                          <div value={'en'} className='LanguageOption' onClick={() => { i18next.changeLanguage('en'); cookies.set('lang', 'en'); setLanguage('English'); setLanguageDropdown(!languagedropdown) }}>Bahasa<br /> Indonesia</div>
                        </div>
                      </div>
                    </div>
                  }

                  <div className='DashboardLanguageItem'>Select language <span style={{ textDecoration: 'underline', cursor: 'pointer' }} onClick={() => setLanguageDropdown(!languagedropdown)}>{language}</span></div>
                  <div className='DashboardCopyrightItem' style={{ marginLeft: '0.5em' }}>&copy; 2024 N3RVE {t('Allrightsreserved')}</div>
                </div>

              </div>
            }

          </div>

        </div>
      }

      <ReactModal
        isOpen={false}
        overlayClassName="Overlay"
        contentLabel="Example Modal"
        style={{
          content: {
            width: '34.125em',
            height: '35.68em',
            margin: 'auto',
            backgroundImage: 'linear-gradient(7.87deg, #182028 50.13%, #273644 96.12%)',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'flex-start',
            borderRadius: '8px',
            border: '0.5px solid rgba(255,255,255,25%)'
          }
        }}
      >

        <img src={crossicon} style={{ height: '1.5em', width: '1.5em', position: 'absolute', right: '1.5em', top: '1.5em', cursor: 'pointer' }} onClick={() => setN3rvePopup(false)} />

        <img src={N3rvePlanLogo} style={{ width: '3em', height: '3em', alignSelf: 'flex-start', marginTop: '2em', marginLeft: '2em' }} />
        <div className='PlanWelcomeHeader' style={{ alignSelf: 'flex-start', marginTop: '1em', marginLeft: '1em' }}>Welcome to N3RVE</div>
        <div className="MfaInputHeader" style={{ marginTop: '1em', marginBottom: '1em' }}>
          Congratulations on taking the first step toward music greatness! With our N3RVE Plan, you're not just making music – you're crafting a journey of triumph.
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', width: '75%' }}>
          <div style={{ display: 'flex', flexDirection: 'row', marginBottom: '1em' }}>
            <img src={N3rvePlusTick} style={{ width: '2em', height: '2em', marginRight: '1em' }} />
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <div className='SwitchPlanPoint'>100% Royalties, Your Way</div>
              <div className='SwitchPlanPointDesc'>Keep every cent you earn. It's your art, your hustle, and your complete reward.</div>
            </div>
          </div>

          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <img src={N3rvePlusTick} style={{ width: '2em', height: '2em', marginRight: '1em' }} />
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <div className='SwitchPlanPoint'>Elevate Your Reach</div>
              <div className='SwitchPlanPointDesc'>Explore tailored resources to grow your career. Access analytics for streaming mastery and optimize platform releases.</div>
            </div>
          </div>
        </div>


        <div className="IUnderstandBtn" style={{ height: '3em', cursor: 'pointer', backgroundColor: '#E91353', backgroundImage: 'none', width: '90%', marginTop: '2em' }} onClick={() => { setN3rvePopup(false); }}>
          Let's Get Started
          <div className="PostLoginBtnOverlay" />

        </div>
      </ReactModal>

      <ReactModal
        isOpen={n3rvePremierPopup}
        overlayClassName="Overlay"
        contentLabel="Example Modal"
        onRequestClose={closen3rvePremierPopup} // closes the modal when the user presses the escape key
        shouldCloseOnOverlayClick={true} // closes the modal when the user clicks outside of it
        style={{
          content: {
            width: '34.125em',
            height: '35.68em',
            margin: 'auto',
            backgroundImage: 'linear-gradient(7.87deg, #182028 50.13%, #273644 96.12%)',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'flex-start',
            borderRadius: '8px',
            border: '0.5px solid rgba(255,255,255,25%)'
          }
        }}
      >

        <img src={crossicon} style={{ height: '1.5em', width: '1.5em', position: 'absolute', right: '1.5em', top: '1.5em', cursor: 'pointer' }} onClick={() => setN3rvePremierPopup(false)} />

        <img src={N3rveProLogo} style={{ width: '3em', height: '3em', alignSelf: 'flex-start', marginTop: '2em', marginLeft: '2em' }} />
        <div className='PlanWelcomeHeader' style={{ alignSelf: 'flex-start', marginTop: '1em', marginLeft: '1em', color: '#75F0E9' }}>Welcome to N3RVE Premier</div>
        <div className="MfaInputHeader" style={{ marginTop: '1em', marginBottom: '1em' }}>
          Welcome to Premier! You've just unlocked a new horizon of possibilities. Let's forge ahead, turning dreams into reality and setting new standards in the music world. Your journey to greatness starts now!
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', width: '75%' }}>
          <div style={{ display: 'flex', flexDirection: 'row', marginBottom: '1em' }}>
            <img src={N3rvePremierTick} style={{ width: '2em', height: '2em', marginRight: '1em' }} />

            <div className='SwitchPlanPoint'>Unlimited DSP Release</div>

          </div>

          <div style={{ display: 'flex', flexDirection: 'row', marginBottom: '1em' }}>
            <img src={N3rvePremierTick} style={{ width: '2em', height: '2em', marginRight: '1em' }} />
            <div className='SwitchPlanPoint'>Youtube Monetization</div>
          </div>

          <div style={{ display: 'flex', flexDirection: 'row', marginBottom: '3em' }}>
            <img src={N3rvePremierTick} style={{ width: '2em', height: '2em', marginRight: '1em' }} />
            <div className='SwitchPlanPoint'>Exclusive Brand/Sync Deals</div>
          </div>
        </div>


        <div className="IUnderstandBtn" style={{ height: '3em', cursor: 'pointer', backgroundColor: '#E91353', backgroundImage: 'none', width: '90%', marginTop: '2em' }} onClick={() => { setN3rvePremierPopup(false); }}>
          Let's Get Started
          <div className="PostLoginBtnOverlay" />

        </div>
      </ReactModal>

      <ReactModal
        isOpen={isOpen}
        contentLabel="Example Modal"
        overlayClassName="Overlay"
        onRequestClose={closeNervePlusPopup} // closes the modal when the user presses the escape key
        shouldCloseOnOverlayClick={true} // closes the modal when the user clicks outside of it
        style={{
          content: {
            width: '30em',
            height: '31.25em',
            margin: 'auto',
            backgroundImage: 'linear-gradient(7.87deg, #182028 50.13%, #273644 96.12%)',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            borderRadius: '8px',
            border: '0.5px solid rgba(255,255,255,25%)'
          }
        }}
      >
        <div className='Popup1Header'>Welcome to N3RVE Plus</div>
        <div className='Popup1Desc'>Congratulations on taking the first step toward music greatness! With our Plus Plan, you're not just making music – you're crafting a journey of triumph.</div>

        <div style={{ display: 'flex', flexDirection: 'row', marginBottom: '1em' }}>
          <img src={PopUpCheck} alt="Check Mark" style={{ width: '2em', height: '2em', marginRight: '0.625em' }} />
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <div className='Popup1CheckHeader'>100% Royalties, Your Way</div>
            <div className='Popup1CheckDesc'>Keep every cent you earn. It's your art, your hustle, and your complete reward.</div>
          </div>

        </div>

        <div style={{ display: 'flex', flexDirection: 'row' }}>
          <img src={PopUpCheck} alt="Check Mark" style={{ width: '2em', height: '2em', marginRight: '0.625em' }} />
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <div className='Popup1CheckHeader'>Elevate Your Reach</div>
            <div className='Popup1CheckDesc'>Explore tailored resources to grow your career.Access analytics for streaming mastery and optimize platform releases.</div>
          </div>

        </div>

        <div className='Btn' style={{ cursor: 'pointer' }} onClick={() => {
          setIsOpen(false);
          setpopUp2(true)
        }}>
          Continue
        </div>

      </ReactModal>

      <ReactModal
        isOpen={popUp2}
        contentLabel="Example Modal"
        overlayClassName="Overlay"
        onRequestClose={closeTOSPopup} // closes the modal when the user presses the escape key
        shouldCloseOnOverlayClick={true} // closes the modal when the user clicks outside of it
        style={{
          content: {
            width: '30em',
            height: '39.43em',
            margin: 'auto',
            backgroundImage: 'linear-gradient(7.87deg, #182028 50.13%, #273644 96.12%)',
            display: 'flex',
            flexDirection: 'column',
            borderRadius: '8px',
            border: '0.5px solid rgba(255,255,255,25%)'
          }
        }}
      >
        <div className='TOSHeader'>Terms of Service</div>
        <div className='TOSDesc'>
          Effective Date: January 31, 2023 <br /> Welcome to the N3RVE Terms of Service! This document governs your use of our services. For your convenience, we have included short summaries of each provision of the Terms of Service at the beginning of each section. However, these summaries do not replace the full legal text, and you agree to read the full Terms of Service to access or use our services.<br />
          <br /> Introduction<br /> By using our Services, you agree to all the provisions in this document, so it is important that you read them carefully. These Terms apply to all users of our Services, and also include a “mandatory arbitration clause and class action waiver.” This means that you agree to resolve any dispute with us through arbitration with a neutral arbitrator, and not in court. You also agree to bring any claims individually, and not as part of a class. Welcome to the Terms of Service (the “Terms”) of N3RVE, Inc., along with its subsidiaries and affiliates worldwide that link to these Terms, including Translation LLC (“N3RVE,” “we,” “our,” or “us”). We provide premium music distribution services for independent artists, facilitate partnerships between artists and brands, maintain a marketplace to buy and sell beats, and offer related services through our mobile applications, websites, and social media pages (collectively referred to by us as the “Services”). These Terms serve as a binding legal agreement between us and all users of the Services we offer (collectively referred to as “users” or “you”).
        </div>

        <div style={{ display: 'flex', flexDirection: 'row', alignSelf: 'center' }}>
          <div className='CancelBtn' style={{ cursor: 'pointer' }}>
            Cancel
          </div>

          <div className='AgreeBtn' style={{ cursor: 'pointer' }} onClick={() => { termsansdconditions() }}>
            Agree
          </div>
        </div>
      </ReactModal>

      <ReactModal
        isOpen={popUp3}
        contentLabel="Example Modal"
        overlayClassName="Overlay"
        onRequestClose={closeCreateProfilePopup} // closes the modal when the user presses the escape key
        shouldCloseOnOverlayClick={true} // closes the modal when the user clicks outside of it
        style={{
          content: {
            width: '30em',
            height: '27.375em',
            margin: 'auto',
            backgroundImage: 'linear-gradient(7.87deg, #182028 50.13%, #273644 96.12%)',
            display: 'flex',
            flexDirection: 'column',
            borderRadius: '8px',
            border: '0.5px solid rgba(255,255,255,25%)',
            overflow: 'visible'
          }
        }}
      >
        <div className='ProfilePopupH1'>Create Your Profile</div>
        <div className='ProfilePopupH2'>What's Your Artist Name?</div>

        <div className='FormHeader'>
          Artist Name
        </div>

        <input
          value={artistName}
          onChange={e => setArtistName(e.target.value)}
          className='FormInput'
          style={{ backgroundColor: 'rgba(0,0,0,16%)', border: '0.5px solid rgba(255,255,255,40%)', width: '25em', borderRadius: '4px', height: '3em', marginLeft: '2em' }}
          type='text'
        />

        <div className='FormHeader' style={{ marginTop: '1em' }}>
          Genre
        </div>

        <Select options={genreOptions} value={genre} onChange={changeGenreHandler}
          components={{
            IndicatorSeparator: () => null
          }}
          styles={
            colourStyles
          }
        />




        <div className='Btn' style={{ cursor: 'pointer', alignSelf: 'center' }} onClick={() => {
          finalizeuser()
        }}>
          Continue
        </div>
      </ReactModal>

      <ReactModal
        isOpen={LogoutPopup}
        overlayClassName="Overlay"
        contentLabel="Example Modal"
        onRequestClose={closeLogoutPopup} // closes the modal when the user presses the escape key
        shouldCloseOnOverlayClick={true} // closes the modal when the user clicks outside of it
        style={{
          content: {
            width: '42.125em',
            height: '9.81em',
            margin: 'auto',
            backgroundImage: 'linear-gradient(7.87deg, #182028 50.13%, #273644 96.12%)',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'space-between',
            borderRadius: '8px',
            border: '0.5px solid rgba(255,255,255,25%)'
          }
        }}
      >
        <div className='LogoutPopupHeader'>
          {t('Areyousureyouwant')}
        </div>
        <img src={crossicon} style={{ height: '1.5em', width: '1.5em', position: 'absolute', right: '1.5em', top: '1.5em', cursor: 'pointer' }} onClick={() => setLogoutPopup(false)} />
        <div style={{ display: 'flex', alignSelf: 'flex-end' }}>
          <div className='CancelBtn' onClick={() => setLogoutPopup(false)}>
            {t('Cancel')}
          </div>
          <div className='LogoutBtn' onClick={() => handleLogout()}>
            {t('Logoutpop')}
            <div className="PostLoginBtnOverlay" />
          </div>
        </div>
      </ReactModal>

    </div>
  );
}

export default Dashboard;